import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';

export default (selector, _room) => useSelector(state => selector(state, _room), isEqual);
